(function() {
  var patched = false;
  var scrollPending = false;

  function getHeaderOffset() {
    var header = document.querySelector('.section-header') || document.querySelector('.header-wrapper');
    var rect;
    var bottom;

    if (!header || !header.getBoundingClientRect) {
      return 0;
    }

    rect = header.getBoundingClientRect();
    bottom = Math.round(rect.bottom);

    if (bottom > 0) {
      return bottom;
    }

    return 0;
  }

  function setNotificationOffset(notification) {
    if (!notification || !notification.style) {
      return;
    }

    notification.style.setProperty('--ps-cart-notification-top', getHeaderOffset() + 'px');
  }

  function getActiveNotification() {
    var notification = document.getElementById('cart-notification');

    if (notification && notification.classList && notification.classList.contains('active')) {
      return notification;
    }

    return null;
  }

  function updateActiveNotificationOffset() {
    var notification = getActiveNotification();

    scrollPending = false;

    if (notification) {
      setNotificationOffset(notification);
    }
  }

  function patchCartNotification() {
    var constructor;
    var originalOpen;

    if (patched || !window.customElements || !window.customElements.get) {
      return;
    }

    constructor = window.customElements.get('cart-notification');
    if (!constructor || !constructor.prototype || !constructor.prototype.open) {
      return;
    }

    originalOpen = constructor.prototype.open;
    constructor.prototype.open = function() {
      var notification = this.notification || document.getElementById('cart-notification');
      var result;

      setNotificationOffset(notification);
      result = originalOpen.apply(this, arguments);
      setNotificationOffset(notification);
      window.setTimeout(function() {
        setNotificationOffset(notification);
      }, 0);

      return result;
    };

    patched = true;
  }

  function handleResize() {
    updateActiveNotificationOffset();
  }

  function handleScroll() {
    if (!getActiveNotification() || scrollPending) {
      return;
    }

    scrollPending = true;

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(updateActiveNotificationOffset);
    } else {
      window.setTimeout(updateActiveNotificationOffset, 16);
    }
  }

  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('cart-notification').then(patchCartNotification);
  } else {
    window.setTimeout(patchCartNotification, 0);
  }

  window.addEventListener('resize', handleResize);
  window.addEventListener('scroll', handleScroll, { passive: true });
})();
